import React from 'react'
import { GoHome } from "react-icons/go";
import { PiBooks } from "react-icons/pi";
import { FaRegCalendarMinus } from "react-icons/fa";
import { PiGraduationCapLight } from "react-icons/pi";
import { NavLink } from 'react-router-dom';
import { MdTask } from "react-icons/md";
import { RiChat1Line } from "react-icons/ri";
import "./Navbar.scss";


function Navbar() {
  return (
    <div className="navbar">
      <div className="navbar_logo">
        <img className='fulllogo' src="/images/serani_ai.png" alt="Serani AI" />
        <img className='tablogo' src="/images/logo2.png" alt="Serani AI" />
      </div>

      <div className="navbar_links">
        <NavLink to="/" className="nav_item">
          <GoHome />
          <p>Home</p>
        </NavLink>
        <NavLink to="/courses" className="nav_item">
          <PiBooks />
          <p>Courses</p>
        </NavLink>
        <NavLink to="/journal" className="nav_item">
          <FaRegCalendarMinus />
          <p>Journals</p>
        </NavLink>
        <NavLink to="/learning" className="nav_item">
          <PiGraduationCapLight />
          <p>Learning</p>
        </NavLink>
        <NavLink to="/chat" className="nav_item">
          <RiChat1Line />
          <p>Chat</p>
        </NavLink>
        <NavLink to="/tasks" className="nav_item">
          <MdTask />
          <p>Tasks</p>
        </NavLink>
      </div>
    </div>
  )
}

export default Navbar
